// Core imports
import * as React from 'react';

// Components imports
import SelectOption from './components/SelectOption';

// Models imports Style and misc imports
import './Select2.scss';
import { ISelectOption } from './components/SelectOption/SelectOption';

interface ISelect2Props {
  options: ISelectOption[];
  selected: ISelectOption;
  label: string;
  placeholder?: string;
  className?: string;
  onError?: boolean;
  onSelect: (item: ISelectOption) => void;
}

interface ISelect2State {
  isOpen: boolean;
}

export class Select2 extends React.Component<ISelect2Props, ISelect2State> {
  private selectRef: any = null;

  public state = {
    isOpen: false
  };

  private handleClickOutside = (e: any) => {
    if (this.selectRef == null || this.selectRef.contains == null) {
      return;
    }
    if (this.selectRef.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    this.setState({
      isOpen: false
    });
  };

  public componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, false);
  }

  private handleToggleDropdown = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  private handleSelect = (item: ISelectOption) => {
    this.setState(
      {
        isOpen: false
      },
      () => {
        this.props.onSelect(item);
      }
    );
  };

  public render() {
    const selectIcon = this.state.isOpen
      ? 'rpds-expand-less'
      : 'rpds-expand-more';
    return (
      <div
        className={`rp-select2 no-select ${this.props.className}`}
        ref={ref => (this.selectRef = ref)}
      >
        <label>{this.props.label}</label>
        <div
          onClick={this.handleToggleDropdown}
          className={`combobox dropdown ${
            this.props.onError ? 'on-error' : ''
          }`}
        >
          <div
            tabIndex={0}
            className={`dropdown-box ${this.props.onError ? 'on-error' : ''}`}
          >
            {this.props.selected
              ? this.props.selected.name
              : this.props.placeholder || ''}
          </div>
          <div
            tabIndex={-1}
            className={`downarrow ${this.props.onError ? 'on-error' : ''}`}
          >
            <span className={selectIcon} />
          </div>
          {this.state.isOpen && (
            <div className="dropdown-list">
              {this.props.options.map((option, i) => (
                <SelectOption
                  option={option}
                  key={i}
                  onSelect={this.handleSelect}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}
